import { render, staticRenderFns } from "./SingularityLeftPanelNew.vue?vue&type=template&id=638b488a&"
import script from "./SingularityLeftPanelNew.vue?vue&type=script&lang=ts&"
export * from "./SingularityLeftPanelNew.vue?vue&type=script&lang=ts&"
import style0 from "./SingularityLeftPanelNew.vue?vue&type=style&index=0&id=638b488a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports